export default {
  id: 'healthHistory/ENVIRONMENTAL_DATA/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.environmentalData',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.environmentalData',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
